/* Site-wide effects: scroll progress bar, header shadow, section rise-in, 3D card tilt. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init() {
    root.classList.add('pr-js');

    /* Progress bar + header shadow */
    var bar = document.createElement('div');
    bar.className = 'pr-progress';
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      var max = root.scrollHeight - root.clientHeight;
      var p = max > 0 ? Math.min(1, root.scrollTop / max) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      var header = document.getElementById('header');
      if (header) { header.classList.toggle('pr-scrolled', root.scrollTop > 10); }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();

    /* Rise-in for content below the fold */
    var main = document.getElementById('main-content');
    var targets = [];
    if (main && !reduce && 'IntersectionObserver' in window) {
      var vh = window.innerHeight || 800;
      var sections = main.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top > vh * 0.9) { targets.push(sections[i]); }
      }
      var cards = main.querySelectorAll('#main-collection-product-grid product-card');
      for (var c = 0; c < cards.length; c++) {
        if (cards[c].getBoundingClientRect().top > vh * 0.9) {
          cards[c].style.transitionDelay = ((c % 4) * 0.06) + 's';
          targets.push(cards[c]);
        }
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });

      for (var t = 0; t < targets.length; t++) {
        targets[t].classList.add('pr-rise');
        io.observe(targets[t]);
      }

      /* Safety net: never leave anything hidden */
      setTimeout(function () {
        for (var k = 0; k < targets.length; k++) { targets[k].classList.add('is-in'); }
      }, 5000);
    }

    /* 3D tilt on product cards (mouse only) */
    if (fine && !reduce) {
      var active = null;
      var reset = function () {
        if (active) { active.style.transform = ''; active = null; }
      };
      document.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') { return; }
        var card = e.target && e.target.closest ? e.target.closest('.product-card') : null;
        if (active && active !== card) { reset(); }
        if (!card) { return; }
        active = card;
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg) translateY(-6px)';
      }, { passive: true });
      document.addEventListener('mouseleave', reset);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
